const { cloneViaJSON } = require('../utils')

const { SENDINGS_FALLBACKS_OPTIONS_CLEAN } = require('./_sendingsFallbacks')
const { TASK_TYPES, TASK_STATES } = require('./_tasks')
const { MODERATION_VALUES } = require('./misc')

const componentsMeta = {
  comment: undefined,
  adminComment: undefined,
  adminCommentPrivate: undefined,
  resellerComment: undefined,
  resellerCommentPrivate: undefined
}

const EMPTY_USERS = {
  username: undefined,
  password: undefined,
  data: {
    firstName: undefined,
    lastName: undefined,
    email: undefined,
    phone: undefined,
    partnership: {
      hasContract: false,
      privacyPolicy: false,
      publicOffer: false
    }
  },
  balance: 0,
  isActive: true
}
const EMPTY_TARIFFS = {
  title: undefined,
  source: undefined,
  data: {
    rules: [],
    hidden: {
      comment: undefined
    },
    options: {
      refundOnFailed: false,
      noPayments: false
    }
  },
  OwnerId: undefined,
  isActive: true
}
const EMPTY_BILLINGS = {
  source: undefined,
  status: undefined,
  amount: 0,
  data: {
    hidden: {
      comment: undefined,
      referredUser: null, // Должно быть по умолчанию null для проверок на backend стороне
      noRef: false
    },
    multiplier: 1,
    price: undefined
  },
  OwnerId: undefined
}
const EMPTY_PROVIDERS = {
  title: undefined,
  comment: undefined,
  properties: {},
  replacements: [],
  isActive: true,
  ServerId: undefined,
  CredentialsId: undefined
}
const EMPTY_PROVIDERGROUPS = {
  title: undefined,
  type: undefined,
  isActive: true
}
const EMPTY_ROUTINGRULES = {
  title: undefined,
  type: undefined,
  rules: [],
  isActive: true
}
const EMPTY_ROUTINGGROUPS = {
  title: undefined,
  type: undefined,
  isActive: true,
  description: undefined
}
const EMPTY_CONTACTLISTS = {
  title: '',
  type: 'regular',
  OwnerId: '',
  isActive: true
}
const EMPTY_CONTACTS = {
  phone: '',
  email: '',
  firstName: '',
  lastName: '',
  middleName: '',
  date: '',
  gender: '',
  ListId: '',
  isActive: true
}
const EMPTY_SENDINGS = {
  type: undefined,
  recipient: {
    include: [],
    exclude: []
  },
  payload: {
    sender: undefined,
    text: undefined,
    button: {
      text: undefined,
      url: undefined
    },
    buttons: [],
    image: undefined,
    file: undefined,
    tts: undefined,
    audio: undefined
  },
  schedule: {
    delay: 0,
    until: undefined
  },
  $options: {
    title: undefined,
    return: undefined,
    ...SENDINGS_FALLBACKS_OPTIONS_CLEAN
  },
  fallbacks: []
}
const EMPTY_SENDERNAMES = {
  name: undefined,
  type: undefined,
  meta: componentsMeta,
  moderation: MODERATION_VALUES.pending,
  isActive: true,
  OwnerId: undefined
}
const EMPTY_PATTERNS = {
  title: undefined,
  type: undefined,
  payload: EMPTY_SENDINGS.payload,
  meta: componentsMeta,
  moderation: MODERATION_VALUES.pending,
  isActive: true
}
const EMPTY_TEMPLATES = {
  title: undefined,
  type: undefined,
  recipient: {
    include: [],
    exclude: []
  },
  payload: {
    sender: undefined,
    text: undefined,
    image: undefined,
    button: {
      text: undefined,
      url: undefined
    }
  },
  fallbacks: [],
  isActive: true
}
const EMPTY_REQUISITES = {
  title: '',
  type: '',
  contact: {
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    phone: ''
  },
  signer: {
    position: {
      nominative: '',
      genitive: ''
    },
    basis: {
      nominative: '',
      genitive: ''
    },
    fullName: {
      nominative: '',
      genitive: ''
    }
  },
  data: {
    legal: {
      businessType: '',
      name: '',
      opf: '',
      ogrn: '',
      inn: '',
      kpp: '',
      okpo: ''
    },
    bank: {
      name: '',
      rs: '',
      ks: '',
      bik: ''
    },
    tax: {
      system: '',
      vat: false
    },
    legalAddress: {
      country: '',
      city: '',
      index: '',
      address: '',
      phone: '',
      phoneAdd: ''
    },
    postalAddress: {
      country: '',
      city: '',
      index: '',
      address: '',
      phone: '',
      phoneAdd: ''
    },
    personal: {
      firstName: '',
      middleName: '',
      lastName: '',
      document: {
        series: '',
        number: '',
        issuer: '',
        issuerCode: '',
        issueDate: '',
        registrationAddress: '',
        registrationDate: '',
        citizenship: ''
      }
    }
  },
  attachments: {},
  isActive: true
}
const EMPTY_TASKS = {
  title: undefined,
  type: TASK_TYPES['billings:operations'],
  data: {
    source: undefined,
    amount: 0,
    frequency: undefined,
    endsAt: undefined
  },
  meta: {},
  state: TASK_STATES.scheduled,
  startsAt: undefined,
  OwnerId: undefined
}
const EMPTY_COMPANIES = {
  title: undefined,
  vat: false,
  OwnerId: undefined
}
const EMPTY_CONTRACTS = {
  title: undefined,
  OwnerId: undefined,
  RequisiteId: undefined,
  CompanyId: undefined,
  FileId: undefined
}
const EMPTY_OPERATORGROUPS = {
  operator: undefined,
  group: undefined,
  mcc: undefined,
  mnc: undefined
}
const EMPTY_RECURRENTPAYMENTS = {
  method: undefined,
  amount: undefined,
  type: undefined,
  status: undefined,
  threshold: undefined,
  frequency: undefined,
  meta: {},
  isActive: true,
  OwnerId: undefined
}
const EMPTY_SERVERS = {
  title: undefined,
  host: undefined,
  port: undefined,
  processor: undefined,
  properties: {},
  isActive: true
}
const EMPTY_CREDENTIALS = {
  title: undefined,
  records: {
    username: undefined,
    password: undefined,
    token: undefined,
    apikey: undefined
  }
}
const EMPTY_TOKENS = {
  token: undefined,
  description: undefined,
  expiredAt: undefined,
  ipWhitelist: undefined,
  OwnerId: undefined
}
const EMPTY_SENDINGSFALLBACKS = {
  SendingId: undefined,
  ParentId: undefined,
  commonId: undefined,
  state: undefined,
  message: {
    type: EMPTY_SENDINGS.type,
    payload: EMPTY_SENDINGS.payload
  },
  conditions: {},
  startedAt: undefined
}
const EMPTY_MESSAGERULES = {
  title: undefined,
  conditions: [],
  actions: {
    type: undefined,
    sender: undefined,
    moderation: undefined,
    text: [],
    fallbacks: [],
    buttons: []
  },
  isActive: true
}
const EMPTY_MESSAGERULEGROUPS = {
  title: undefined,
  isActive: true
}
const EMPTY_KEYWORDS = {
  regexp: undefined
}
const EMPTY_KEYWORDLISTS = {
  title: undefined,
  isActive: true
}
const EMPTY_YCLIENTS = {
  salonId: undefined,
  isActive: true,
  error: undefined,
  OwnerId: undefined,
  TokenId: undefined
}

const EMPTY_INVOICES = {
  amount: 0,
  companyId: undefined,
  requisiteId: undefined,
  customerId: undefined,
  documentId: undefined,
  status: undefined,
  ownerId: undefined
}
const EMPTY_OTP_SETTINGS_WIDGETS = {
  name: undefined,
  styles: {},
  isActive: true,
  isBlocked: false,
  captchaIsRequired: false,
  ownerId: undefined
}
const EMPTY_OTP_SETTINGS_CHANNELS = {
  name: undefined,
  channelType: undefined,
  additionalSettings: {
    code: {
      length: 4,
      beautify: true
    },
    lifetime: 60,
    numberOfTries: 1,
    numberOfRestart: undefined,
    mtsClientId: undefined
  }
}
const EMPTY_OTP_SETTINGS_TEMPLATES = {
  name: undefined,
  ownerId: undefined,
  channelType: undefined,
  conditions: [],
  additionalSettings: {
    senderId: undefined,
    template: 'Ваш код {{ code }}.'
  }
}

const exp = {
  EMPTY_USERS,
  EMPTY_TARIFFS,
  EMPTY_BILLINGS,
  EMPTY_PROVIDERS,
  EMPTY_PROVIDERGROUPS,
  EMPTY_ROUTINGRULES,
  EMPTY_ROUTINGGROUPS,
  EMPTY_CONTACTLISTS,
  EMPTY_CONTACTS,
  EMPTY_SENDINGS,
  EMPTY_SENDERNAMES,
  EMPTY_PATTERNS,
  EMPTY_TEMPLATES,
  EMPTY_REQUISITES,
  EMPTY_TASKS,
  EMPTY_COMPANIES,
  EMPTY_CONTRACTS,
  EMPTY_OPERATORGROUPS,
  EMPTY_RECURRENTPAYMENTS,
  EMPTY_SERVERS,
  EMPTY_CREDENTIALS,
  EMPTY_TOKENS,
  EMPTY_SENDINGSFALLBACKS,
  EMPTY_MESSAGERULES,
  EMPTY_MESSAGERULEGROUPS,
  EMPTY_KEYWORDS,
  EMPTY_KEYWORDLISTS,
  EMPTY_YCLIENTS,
  EMPTY_INVOICES,
  EMPTY_OTP_SETTINGS_WIDGETS,
  EMPTY_OTP_SETTINGS_CHANNELS,
  EMPTY_OTP_SETTINGS_TEMPLATES
}

const EMPTY = Object.keys(exp).reduce((result, key) =>
  Object.assign(result, {
    get [key.replace(/^EMPTY_/, '')]() {
      return cloneViaJSON(exp[key])
    }
  }),
{})

module.exports = {
  EMPTY,
  ...exp
}
